import { RouterProvider } from 'react-router-dom'
import { router } from '@/routes'
import { useAuthListener } from '@/features/auth/hooks/use-auth-listener'

export default function App() {
  useAuthListener()
  return <RouterProvider router={router} />
}
